// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__wEfvo","tab":"TabsNew_tab__3q40X"};